import React from 'react';
import { FadeIn } from './FadeIn';
import { SmartphoneIcon, DatabaseIcon, LayersIcon, ArrowDownIcon, ArrowUpIcon } from 'lucide-react';
export function PlatformArchitecture() {
  return <section className="py-24 bg-navy relative" data-id="element-189">
      <div className="max-w-7xl mx-auto px-6" data-id="element-190">
        <FadeIn className="text-center mb-16" data-id="element-191">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-192">
            Built to Integrate. Designed to Scale.
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-193">
            A frictionless architecture that sits securely between your core
            systems and your customers.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-194">
          <div className="max-w-4xl mx-auto relative" data-id="element-195">
            {/* Top Layer: Digital Channels */}
            <div className="bg-slate border border-white/10 rounded-xl p-6 text-center relative z-10 shadow-lg" data-id="element-196">
              <div className="flex items-center justify-center gap-3 mb-2 text-white" data-id="element-197">
                <SmartphoneIcon className="w-6 h-6 text-blue" data-id="element-198" />
                <h3 className="text-xl font-semibold" data-id="element-199">
                  Your Brand & Digital Channels
                </h3>
              </div>
              <p className="text-sm text-gray-400" data-id="element-200">
                Web, Mobile App, API Consumers
              </p>
            </div>

            {/* Connecting Lines Down */}
            <div className="flex justify-center py-4 relative" data-id="element-201">
              <div className="w-px h-12 bg-gradient-to-b from-blue/50 to-teal/50 relative" data-id="element-202">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-blue animate-ping" data-id="element-203"></div>
                <ArrowDownIcon className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-4 h-4 text-teal" data-id="element-204" />
              </div>
            </div>

            {/* Middle Layer: FIQIS Platform */}
            <div className="bg-gradient-to-br from-teal/10 to-blue/5 border border-teal/30 rounded-2xl p-8 relative z-10 shadow-[0_0_50px_rgba(0,212,170,0.1)]" data-id="element-205">
              <div className="absolute -top-3 left-8 bg-navy px-3 text-xs font-bold tracking-widest text-teal uppercase border border-teal/30 rounded-full" data-id="element-206">
                FIQIS Platform
              </div>

              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4" data-id="element-207">
                {['Secure Integration', 'AI Intelligence', 'Micro-Lending', 'Embedded P2P'].map((module, i) => <div key={i} className="bg-navy/80 backdrop-blur-sm border border-white/10 rounded-lg p-4 text-center hover:border-teal/50 transition-colors cursor-default group" data-id="element-208">
                    <LayersIcon className="w-5 h-5 text-teal mx-auto mb-2 opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-209" />
                    <span className="text-sm font-medium text-white" data-id="element-210">
                      {module}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Connecting Lines Down */}
            <div className="flex justify-center py-4 relative" data-id="element-211">
              <div className="w-px h-12 bg-gradient-to-b from-teal/50 to-white/20 relative" data-id="element-212">
                <ArrowUpIcon className="absolute -top-3 left-1/2 -translate-x-1/2 w-4 h-4 text-teal" data-id="element-213" />
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-white/50 animate-ping" style={{
                animationDelay: '1s'
              }} data-id="element-214"></div>
              </div>
            </div>

            {/* Bottom Layer: Core Systems */}
            <div className="bg-slate border border-white/10 rounded-xl p-6 text-center relative z-10 shadow-lg" data-id="element-215">
              <div className="flex items-center justify-center gap-3 mb-2 text-white" data-id="element-216">
                <DatabaseIcon className="w-6 h-6 text-gray-400" data-id="element-217" />
                <h3 className="text-xl font-semibold" data-id="element-218">
                  Core Banking Systems & Third Parties
                </h3>
              </div>
              <p className="text-sm text-gray-400" data-id="element-219">
                Legacy Cores, Payment Gateways, Identity Providers
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}